<template>
  <AreaAccordion
    :options="options"
    :value="value"
    @added="add($event)"
    @updated="update($event)"
    @removed="remove($event)"
  />
</template>

<script>
import { mapMutations, mapState } from "vuex";
import AreaAccordion from "./AreaAccordion.vue";

export default {
  name: "ExteriorCoatingAreaAccordion",

  components: { AreaAccordion },

  props: {
    options: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapState("coatingCalculator", { value: "exteriorAreas" }),
  },

  methods: {
    ...mapMutations("coatingCalculator", {
      add: "addExteriorArea",
      remove: "removeExteriorArea",
      update: "updateExteriorArea",
    }),
  },
};
</script>
